@let formControlValue = control();

<aiwyn-editor
  [formControl]="formControlValue"
  [init]="init$ | async"
  [valueParser]="parseValue"
  [valueSerializer]="serializeValue"
  (editorInit)="onEditorInit($event)"
/>

<div class="insert-variable">
  <button dataSelector="insert-variable-menu-trigger" type="button" [matMenuTriggerFor]="variableMenu">
    Insert Variable
    <anduin-icon name="chevron-down" aria-hidden="true" height="20" width="20" />
  </button>
  <mat-menu #variableMenu="matMenu">
    @for (variable of variables$ | async; track variable[0]) {
      <button [dataSelector]="'insert-variable-' + variable[0]" type="button" (click)="insertVariable(variable[1])" mat-menu-item>
        {{ variable[0] }}
      </button>
    }
  </mat-menu>
</div>
